// MaterialIcon.tsx
import { MaterialSymbol } from '@material-symbols/font-400';
import React from 'react';

interface MaterialIconProps {
    className?: string | undefined;
    icon: MaterialSymbol;
    style?: 'outlined' | 'round' | 'sharp' | 'two-tone' | 'filled';
    size?: number | string;
    color?: string;
    marginRight?: string;
    marginLeft?: string;
    zIndex?: number;
    onClick?: (e: React.MouseEvent<HTMLSpanElement, MouseEvent>) => void;
}

const MaterialIcon: React.FC<MaterialIconProps> = ({
    className,
    icon,
    style = 'outlined',
    size = 24,
    color = 'inherit',
    marginRight = '0px',
    marginLeft = '0px',
    zIndex,
    onClick
}) => {
    return (
        <span
            className={`material-symbols-${style} ${className ?? ""}`}
            translate="no"
            style={{
                fontSize: size,
                color,
                marginRight,
                marginLeft,
                cursor: onClick ? "pointer" : "inherit",
                zIndex: zIndex
            }}
            onClick={onClick}
        >
            {icon}
        </span>
    );
};

export default MaterialIcon;
